import { render, staticRenderFns } from "./bank.vue?vue&type=template&id=2c133c4a&scoped=true&lang=html&"
import script from "./bank.vue?vue&type=script&lang=js&"
export * from "./bank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c133c4a",
  null
  
)

export default component.exports